
import { defineComponent } from "vue";
import Icon from "./Icon.vue";

export default defineComponent({
    name: "v-checkbox",
    components: {
        Icon,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            required: false,
            default: false,
        },
        checkbox_width: {
            type:Number,
            required: false,
            default:28,
        },
        required:{
            type: Boolean,
        },
        checked_image: {
            type: String,
            required: false,
            default: 'images/papsi_ck_on_icon.svg',
        },

    },
    data() {
        return {
            status: false,
            image: 'images/papsi_ck_off_icon.svg',
        }
    },
    mounted() {
        this.status = this.checked;
    },
    methods: {
        toggle() {
            this.status = !this.status;
            this.setImage();
        },
        setImage() {
            this.image = this.status ? this.checked_image : 'images/papsi_ck_off_icon.svg';
        },
    },
    watch: {
        status(n : any) {
            this.setImage();
            this.$emit('changed', n);
        },
        checked(n : any) {
            this.status = n;
        },
    },
})
